import { Suspense, lazy, memo } from 'react'

import { TPageProps } from '~/shared/types/commonTypes'

const Gain = lazy(
  () => import('~/pages/onboarding/multipleChoice/libs/components/Gain'),
)
const Distraction = lazy(
  () => import('~/pages/onboarding/multipleChoice/libs/components/Distraction'),
)
const KindOfLearning = lazy(
  () =>
    import('~/pages/onboarding/multipleChoice/libs/components/KindOfLearning'),
)
const SpecificReason = lazy(
  () =>
    import('~/pages/onboarding/multipleChoice/libs/components/SpecificReason'),
)
const Topic = lazy(
  () => import('~/pages/onboarding/multipleChoice/libs/components/Topic'),
)
const BiologyCuriosity = lazy(
  () =>
    import(
      '~/pages/onboarding/multipleChoice/libs/components/BiologyCuriosity'
    ),
)

const MultipleChoiceRoot = ({ nextPagePath, pageId }: TPageProps) => (
  <Suspense fallback={null}>
    <Gain nextPagePath={nextPagePath} pageId={pageId} />
    <Distraction nextPagePath={nextPagePath} pageId={pageId} />
    <KindOfLearning nextPagePath={nextPagePath} pageId={pageId} />
    <SpecificReason nextPagePath={nextPagePath} pageId={pageId} />
    <BiologyCuriosity nextPagePath={nextPagePath} pageId={pageId} />
    <Topic nextPagePath={nextPagePath} pageId={pageId} />
  </Suspense>
)

const MultipleChoice = Object.assign(memo(MultipleChoiceRoot), {
  Gain,
  Distraction,
  KindOfLearning,
  SpecificReason,
  Topic,
  BiologyCuriosity,
})

export default MultipleChoice
